import { apiFetch } from "./client";
import type { Customer, Page } from "./types";

export interface ListParams {
  limit?: number;
  offset?: number;
}

export interface CustomerCseAssignmentPayload {
  cse_id: number;
  is_permanent: boolean;
  start_date: string | null;
  end_date: string | null;
}

export interface CustomerPayload {
  customer_no: string;
  name: string;
  double_deckers_allowed?: boolean;
  max_pallet_count_per_load?: number | null;
  default_haulier_id?: number | null;
  rate_card_id?: number | null;
  cse_id?: number | null;
  phone_numbers?: string[];
  contact_emails?: string[];
  cse_assignments?: CustomerCseAssignmentPayload[];
  linked_customer_ids?: number[];
}

export async function listCustomers(params: ListParams = {}): Promise<Page<Customer>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/customers${query ? `?${query}` : ""}`);
}

export async function createCustomer(data: CustomerPayload): Promise<Customer> {
  return apiFetch("/customers", { method: "POST", body: JSON.stringify(data) });
}

export async function getCustomer(id: number): Promise<Customer> {
  return apiFetch(`/customers/${id}`);
}

export async function updateCustomer(
  id: number,
  data: Partial<CustomerPayload>,
): Promise<Customer> {
  return apiFetch(`/customers/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteCustomer(id: number): Promise<unknown> {
  return apiFetch(`/customers/${id}`, { method: "DELETE" });
}
